import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./GerenciarHorarios.css";

const GerenciarHorarios = () => {
    const [activeTab, setActiveTab] = useState("horarios");
    const [horarios, setHorarios] = useState([]);
    const [pausas, setPausas] = useState([]);
    const [funcionarios, setFuncionarios] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [editando, setEditando] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const [formData, setFormData] = useState({
        funcionario_id: "",
        dia_da_semana: "",
        horario_inicio: "",
        horario_fim: ""
    });

    const navigate = useNavigate();

    const diasSemana = [
        { value: "segunda", label: "Segunda" },
        { value: "terca", label: "Terça" },
        { value: "quarta", label: "Quarta" },
        { value: "quinta", label: "Quinta" },
        { value: "sexta", label: "Sexta" },
        { value: "sabado", label: "Sábado" },
        { value: "domingo", label: "Domingo" }
    ];

    useEffect(() => {
        carregarDados();

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        const bloquearInspecao = (event) => {
            if (
                event.key === "F12" ||
                (event.ctrlKey && event.shiftKey && event.key === "I")
            ) {
                event.preventDefault();
            }
        };

        window.addEventListener("resize", handleResize);
        document.addEventListener("keydown", bloquearInspecao);

        return () => {
            window.removeEventListener("resize", handleResize);
            document.removeEventListener("keydown", bloquearInspecao);
        };
    }, []);

    const carregarDados = async () => {
        try {
            setCarregando(true);

            const funcResponse = await axios.get(
                "https://acesso.cronosagenda.com.br/api/funcionarios",
                { withCredentials: true }
            );
            setFuncionarios(funcResponse.data || []);

            const horariosResponse = await axios.get(
                "https://acesso.cronosagenda.com.br/api/horarios_funcionamento",
                { withCredentials: true }
            );
            setHorarios(horariosResponse.data || []);

            const pausasResponse = await axios.get(
                "https://acesso.cronosagenda.com.br/api/pausas",
                { withCredentials: true }
            );
            setPausas(pausasResponse.data || []);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
            setMensagem("Erro ao carregar dados");
        } finally {
            setCarregando(false);
        }
    };

    const resetForm = () => {
        setFormData({
            funcionario_id: "",
            dia_da_semana: "",
            horario_inicio: "",
            horario_fim: ""
        });
        setEditando(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEditar = (item, tipo) => {
        setEditando({ tipo, id: item.id });

        setFormData({
            funcionario_id: item.funcionario_id.toString(),
            dia_da_semana: item.dia_da_semana,
            horario_inicio: item.horario_inicio,
            horario_fim: item.horario_fim
        });

        if (isMobile) {
            setTimeout(() => {
                document
                    .querySelector(".gh-form")
                    ?.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
            }, 100);
        }
    };

    const handleCancelarEdicao = () => {
        resetForm();
        setMensagem("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensagem("");

        if (
            !formData.funcionario_id ||
            !formData.dia_da_semana ||
            !formData.horario_inicio ||
            !formData.horario_fim
        ) {
            setMensagem("Todos os campos são obrigatórios");
            return;
        }

        if (formData.horario_inicio >= formData.horario_fim) {
            setMensagem("O horário de início deve ser antes do horário de fim");
            return;
        }

        try {
            setCarregando(true);

            let response;
            const url = "https://acesso.cronosagenda.com.br/api";

            if (editando) {
                if (editando.tipo === "horario") {
                    response = await axios.put(
                        `${url}/horarios_funcionamento/${editando.id}`,
                        formData,
                        { withCredentials: true }
                    );
                } else {
                    response = await axios.put(
                        `${url}/pausas/${editando.id}`,
                        formData,
                        { withCredentials: true }
                    );
                }
            } else if (activeTab === "horarios") {
                response = await axios.post(
                    `${url}/horarios_funcionamento`,
                    formData,
                    { withCredentials: true }
                );
            } else {
                response = await axios.post(
                    `${url}/pausas`,
                    formData,
                    { withCredentials: true }
                );
            }

            setMensagem(response.data.message);
            resetForm();
            await carregarDados();
        } catch (error) {
            console.error("Erro ao salvar:", error);
            setMensagem(error.response?.data?.error || "Erro ao salvar");
        } finally {
            setCarregando(false);
        }
    };

    const handleExcluir = async (id, tipo) => {
        const nomeTipo = tipo === "horario" ? "horário" : "pausa";

        if (!window.confirm(`Tem certeza que deseja excluir este ${nomeTipo}?`)) {
            return;
        }

        try {
            setCarregando(true);
            setMensagem("");

            const url = "https://acesso.cronosagenda.com.br/api";

            const response = await axios.delete(
                `${url}/${tipo === "horario" ? "horarios_funcionamento" : "pausas"}/${id}`,
                { withCredentials: true }
            );

            setMensagem(response.data.message);
            await carregarDados();
        } catch (error) {
            console.error("Erro ao excluir:", error);
            setMensagem(error.response?.data?.error || "Erro ao excluir");
        } finally {
            setCarregando(false);
        }
    };

    const getDiaLabel = (valor) =>
        diasSemana.find((dia) => dia.value === valor)?.label || valor || "—";

    const currentData = activeTab === "horarios" ? horarios : pausas;
    const currentLabel = activeTab === "horarios" ? "horário" : "pausa";
    const tipoAtual = activeTab === "horarios" ? "horario" : "pausa";
    const mensagemSucesso =
        mensagem.toLowerCase().includes("sucesso") ||
        mensagem.toLowerCase().includes("atualizado") ||
        mensagem.toLowerCase().includes("adicionado") ||
        mensagem.toLowerCase().includes("excluído") ||
        mensagem.toLowerCase().includes("salvo");

    const MobileListItem = ({ item, tipo }) => (
        <article className="gh-mobile-card" key={item.id}>
            <div className="gh-mobile-card-header">
                <div className="gh-avatar">
                    {(item.funcionario_nome || "P").charAt(0).toUpperCase()}
                </div>

                <div className="gh-mobile-person">
                    <strong>{item.funcionario_nome || "Profissional"}</strong>
                    <span>{getDiaLabel(item.dia_da_semana)}</span>
                </div>

                <span
                    className={`gh-type-badge ${
                        tipo === "horario" ? "gh-type-hours" : "gh-type-break"
                    }`}
                >
                    {tipo === "horario" ? "Expediente" : "Pausa"}
                </span>
            </div>

            <div className="gh-mobile-time">
                <span className="gh-time-icon">◷</span>
                <div>
                    <small>Intervalo</small>
                    <strong>
                        {item.horario_inicio} – {item.horario_fim}
                    </strong>
                </div>
            </div>

            <div className="gh-mobile-actions">
                <button
                    type="button"
                    className="gh-btn gh-btn-edit"
                    onClick={() => handleEditar(item, tipo)}
                    disabled={carregando}
                >
                    <span>✎</span> Editar
                </button>

                <button
                    type="button"
                    className="gh-btn gh-btn-delete"
                    onClick={() => handleExcluir(item.id, tipo)}
                    disabled={carregando}
                >
                    <span>×</span> Excluir
                </button>
            </div>
        </article>
    );

    return (
        <main className="gh-page">
            <div className="gh-container">
                <header className="gh-header">
                    <div className="gh-header-icon" aria-hidden="true">
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect x="3" y="5" width="18" height="16" rx="3" />
                            <path d="M16 3v4M8 3v4M3 10h18" />
                            <path d="m9 15 2 2 4-4" />
                        </svg>
                    </div>

                    <div className="gh-header-copy">
                        <span className="gh-eyebrow">CONFIGURAÇÕES DA AGENDA</span>
                        <h1>Horários e pausas</h1>
                        <p>
                            Organize os expedientes e intervalos de cada profissional.
                        </p>
                    </div>
                </header>

                <section className="gh-summary">
                    <div className="gh-summary-item">
                        <span className="gh-summary-icon gh-summary-purple">◷</span>
                        <div>
                            <strong>{horarios.length}</strong>
                            <span>Horários cadastrados</span>
                        </div>
                    </div>

                    <div className="gh-summary-divider" />

                    <div className="gh-summary-item">
                        <span className="gh-summary-icon gh-summary-orange">☕</span>
                        <div>
                            <strong>{pausas.length}</strong>
                            <span>Pausas cadastradas</span>
                        </div>
                    </div>

                    <div className="gh-summary-divider" />

                    <div className="gh-summary-item">
                        <span className="gh-summary-icon gh-summary-blue">♙</span>
                        <div>
                            <strong>{funcionarios.length}</strong>
                            <span>Profissionais</span>
                        </div>
                    </div>
                </section>

                {mensagem && (
                    <div
                        className={`gh-alert ${
                            mensagemSucesso ? "gh-alert-success" : "gh-alert-error"
                        }`}
                        role="status"
                    >
                        <span className="gh-alert-symbol">
                            {mensagemSucesso ? "✓" : "!"}
                        </span>
                        <p>{mensagem}</p>
                        <button
                            type="button"
                            onClick={() => setMensagem("")}
                            aria-label="Fechar mensagem"
                        >
                            ×
                        </button>
                    </div>
                )}

                <section className="gh-panel">
                    <div className="gh-tabs" role="tablist" aria-label="Tipo de cadastro">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "horarios"}
                            className={`gh-tab ${
                                activeTab === "horarios" ? "gh-tab-active" : ""
                            }`}
                            onClick={() => {
                                setActiveTab("horarios");
                                resetForm();
                                setMensagem("");
                            }}
                        >
                            <span className="gh-tab-icon">◷</span>
                            Horários de funcionamento
                            <span className="gh-tab-count">{horarios.length}</span>
                        </button>

                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === "pausas"}
                            className={`gh-tab ${
                                activeTab === "pausas" ? "gh-tab-active" : ""
                            }`}
                            onClick={() => {
                                setActiveTab("pausas");
                                resetForm();
                                setMensagem("");
                            }}
                        >
                            <span className="gh-tab-icon">☕</span>
                            Pausas
                            <span className="gh-tab-count">{pausas.length}</span>
                        </button>
                    </div>

                    <div className="gh-form-section">
                        <div className="gh-section-heading">
                            <div className="gh-section-number">
                                {editando ? "✎" : "+"}
                            </div>
                            <div>
                                <h2>
                                    {editando
                                        ? `Editar ${editando.tipo === "horario" ? "horário" : "pausa"}`
                                        : `Adicionar ${activeTab === "horarios" ? "horário" : "pausa"}`}
                                </h2>
                                <p>
                                    {editando
                                        ? "Altere os dados e salve as modificações."
                                        : "Preencha os campos para configurar a agenda do profissional."}
                                </p>
                            </div>
                        </div>

                        <form className="gh-form" onSubmit={handleSubmit}>
                            <div className="gh-form-grid">
                                <div className="gh-field gh-field-full">
                                    <label htmlFor="gh-funcionario">
                                        Profissional <span>*</span>
                                    </label>
                                    <div className="gh-input-wrap">
                                        <span className="gh-input-icon">♙</span>
                                        <select
                                            id="gh-funcionario"
                                            name="funcionario_id"
                                            value={formData.funcionario_id}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Selecione um profissional</option>
                                            {funcionarios.map((func) => (
                                                <option key={func.id} value={func.id}>
                                                    {func.nome}
                                                </option>
                                            ))}
                                        </select>
                                        <span className="gh-select-arrow">⌄</span>
                                    </div>
                                </div>

                                <div className="gh-field gh-field-full">
                                    <label htmlFor="gh-dia">
                                        Dia da semana <span>*</span>
                                    </label>
                                    <div className="gh-input-wrap">
                                        <span className="gh-input-icon">▦</span>
                                        <select
                                            id="gh-dia"
                                            name="dia_da_semana"
                                            value={formData.dia_da_semana}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Selecione o dia</option>
                                            {diasSemana.map((dia) => (
                                                <option key={dia.value} value={dia.value}>
                                                    {dia.label}
                                                </option>
                                            ))}
                                        </select>
                                        <span className="gh-select-arrow">⌄</span>
                                    </div>
                                </div>

                                <div className="gh-field">
                                    <label htmlFor="gh-inicio">
                                        Horário de início <span>*</span>
                                    </label>
                                    <div className="gh-input-wrap">
                                        <span className="gh-input-icon">◷</span>
                                        <input
                                            id="gh-inicio"
                                            type="time"
                                            name="horario_inicio"
                                            value={formData.horario_inicio}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="gh-field">
                                    <label htmlFor="gh-fim">
                                        Horário de fim <span>*</span>
                                    </label>
                                    <div className="gh-input-wrap">
                                        <span className="gh-input-icon">◴</span>
                                        <input
                                            id="gh-fim"
                                            type="time"
                                            name="horario_fim"
                                            value={formData.horario_fim}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="gh-form-hint">
                                <span>ⓘ</span>
                                O horário de início deve ser anterior ao horário de fim.
                            </div>

                            <div className="gh-form-actions">
                                {editando && (
                                    <button
                                        type="button"
                                        className="gh-btn gh-btn-cancel"
                                        onClick={handleCancelarEdicao}
                                        disabled={carregando}
                                    >
                                        Cancelar edição
                                    </button>
                                )}

                                <button
                                    type="submit"
                                    className="gh-btn gh-btn-primary"
                                    disabled={carregando}
                                >
                                    {carregando ? (
                                        <>
                                            <span className="gh-spinner" />
                                            Salvando...
                                        </>
                                    ) : (
                                        <>
                                            <span>{editando ? "✓" : "+"}</span>
                                            {editando ? "Salvar alterações" : "Adicionar cadastro"}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </section>

                <section className="gh-list-section">
                    <div className="gh-list-heading">
                        <div>
                            <span className="gh-eyebrow">SEUS CADASTROS</span>
                            <h2>
                                {activeTab === "horarios"
                                    ? "Horários cadastrados"
                                    : "Pausas cadastradas"}
                            </h2>
                            <p>
                                {currentData.length === 1
                                    ? `1 ${currentLabel} cadastrado`
                                    : `${currentData.length} ${currentLabel === "horário" ? "horários" : "pausas"} cadastrados`}
                            </p>
                        </div>

                        <span className="gh-total-badge">{currentData.length} registros</span>
                    </div>

                    {carregando ? (
                        <div className="gh-state">
                            <span className="gh-large-spinner" />
                            <strong>Carregando informações...</strong>
                            <p>Estamos atualizando os dados da sua agenda.</p>
                        </div>
                    ) : currentData.length === 0 ? (
                        <div className="gh-state">
                            <div className="gh-empty-icon">
                                {activeTab === "horarios" ? "◷" : "☕"}
                            </div>
                            <strong>Nenhum {currentLabel} cadastrado</strong>
                            <p>
                                Use o formulário acima para adicionar o primeiro cadastro.
                            </p>
                        </div>
                    ) : isMobile ? (
                        <div className="gh-mobile-list">
                            {currentData.map((item) => (
                                <MobileListItem
                                    key={item.id}
                                    item={item}
                                    tipo={tipoAtual}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="gh-table-wrap">
                            <table className="gh-table">
                                <thead>
                                    <tr>
                                        <th>Profissional</th>
                                        <th>Dia da semana</th>
                                        <th>Início</th>
                                        <th>Fim</th>
                                        <th className="gh-actions-column">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <div className="gh-table-person">
                                                    <div className="gh-avatar">
                                                        {(item.funcionario_nome || "P")
                                                            .charAt(0)
                                                            .toUpperCase()}
                                                    </div>
                                                    <strong>
                                                        {item.funcionario_nome || "Profissional"}
                                                    </strong>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="gh-day-badge">
                                                    {getDiaLabel(item.dia_da_semana)}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="gh-time-value">
                                                    {item.horario_inicio}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="gh-time-value">
                                                    {item.horario_fim}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="gh-table-actions">
                                                    <button
                                                        type="button"
                                                        className="gh-icon-btn gh-icon-edit"
                                                        onClick={() =>
                                                            handleEditar(item, tipoAtual)
                                                        }
                                                        disabled={carregando}
                                                        title="Editar cadastro"
                                                    >
                                                        ✎
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="gh-icon-btn gh-icon-delete"
                                                        onClick={() =>
                                                            handleExcluir(item.id, tipoAtual)
                                                        }
                                                        disabled={carregando}
                                                        title="Excluir cadastro"
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </section>

                <button
                    type="button"
                    className="gh-back-button"
                    onClick={() => navigate("/dashboard")}
                >
                    <span>←</span>
                    Voltar para o dashboard
                </button>

                <footer className="gh-footer">
                    <span className="gh-footer-dot" />
                    Cronos Agenda · Gestão de horários
                </footer>
            </div>
        </main>
    );
};

export default GerenciarHorarios;